<template>
  <div>
    <b-row>
      <router-link to="/books"  class="rounded-pill btn-outline p-2 px-3">#Books</router-link> &nbsp;
      <router-link to="/drinks"  class="rounded-pill btn-outline p-2 px-3">#Drinks</router-link> &nbsp;
      <router-link to="/electronics"  class="rounded-pill btn-outline p-2 px-3">#Electronics</router-link> &nbsp;
      <router-link to="/fashion"  class="rounded-pill btn-outline p-2 px-3">#Fashion</router-link> &nbsp;
      <router-link to="/foods"  class="rounded-pill btn-outline p-2 px-3">#Foods</router-link> &nbsp;
      <router-link to="/furniture"  class="rounded-pill btn-outline p-2 px-3">#Furniture</router-link> &nbsp;
      <router-link to="/otomotif"  class="rounded-pill btn-outline p-2 px-3">#Otomotif</router-link> &nbsp;
      <router-link to="/others"  class="rounded-pill btn-outline p-2 px-3">#others</router-link> &nbsp;
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'NavbarCategory'
}
</script>

<style>

</style>
